import { EyeIcon } from 'icons';
import { forwardRef, useState } from 'react';
import { TextInput } from 'shared/ui/Inputs';
import type { Props as TextInputProps } from 'shared/ui/Inputs/TextInput';

export type TextInputPasswordProps = TextInputProps;

export const TextInputPassword = forwardRef<
  HTMLInputElement,
  TextInputPasswordProps
>((TextInputMantineProps, ref) => {
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  return (
    <TextInput
      ref={ref}
      {...TextInputMantineProps}
      type={isPasswordShown ? 'text' : 'password'}
      rightIcon={<EyeIcon color={isPasswordShown ? 'primary' : 'primary.9'} />}
      rightIconAction={() => {
        setIsPasswordShown(isShown => !isShown);
      }}
    />
  );
});
